const username = process.env.NEXT_PUBLIC_AB_TEST_CLIENT_ID || ''
const password = process.env.NEXT_PUBLIC_AB_TEST_CLIENT_SECRET || ''

export const EXPERIMENT_CONFIG = {
  debug: process.env.NEXT_PUBLIC_AB_TEST_DEBUG === 'true' || false,
  baseUrl: process.env.NEXT_PUBLIC_AB_TEST_BASE_URL || '',
  credentials: btoa(`${username}:${password}`),
}
